import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-share-options',
  template: `
    <ion-list>
      <ion-item
        button
        (click)="copyLink()"
      >
        <ion-icon
          name="copy-outline"
          slot="start"
        ></ion-icon>
        <ion-label>Copy Link</ion-label>
      </ion-item>
      <ion-item
        button
        (click)="shareOnWhatsApp()"
      >
        <ion-icon
          name="logo-whatsapp"
          slot="start"
        ></ion-icon>
        <ion-label>Share on WhatsApp</ion-label>
      </ion-item>
      <ion-item
        button
        (click)="shareOnFacebook()"
      >
        <ion-icon
          name="logo-facebook"
          slot="start"
        ></ion-icon>
        <ion-label>Share on Facebook</ion-label>
      </ion-item>
    </ion-list>
  `,
  styles: [
    `
      ion-list {
        padding: 0;
      }
      ion-item {
        --padding-start: 16px;
        --padding-end: 16px;
        --min-height: 48px;
      }
      ion-icon {
        font-size: 20px;
      }
    `,
  ],
})
export class ShareOptionsComponent {
  @Input() itemId: string;
  @Input() itemType: string;
  @Input() itemTitle: string;

  constructor(private popoverController: PopoverController) {}

  private getShareUrl(): string {
    const baseUrl = environment.hostUrl || window.location.origin;
    return `${baseUrl}/${this.itemType}/${this.itemId}`;
  }

  async copyLink() {
    const url = this.getShareUrl();
    await navigator.clipboard.writeText(url);
    this.dismiss();
  }

  shareOnWhatsApp() {
    const url = this.getShareUrl();
    const text = `Check out this ${this.itemType}: ${this.itemTitle}\n${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
    this.dismiss();
  }

  shareOnFacebook() {
    const url = this.getShareUrl();
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      '_blank'
    );
    this.dismiss();
  }

  dismiss() {
    this.popoverController.dismiss();
  }
}

